/* eslint-disable import/no-cycle */
import {useTranslation} from 'react-i18next';
import {Form} from 'antd';
import Modal from '../modal/Modal';
import WidgetSettingsForm from './WidgetSettingsForm';
import {useStore} from '../../../hooks/useStore';
import {useMount} from '../../../hooks/useMount';

const WidgetSettingsModal = ({widgetConfig, onOk, ...props}) => {
  const store = useStore();
  const {t} = useTranslation();
  const [form] = Form.useForm();

  const handleSubmit = () => (form.submit());

  useMount(() => {
    widgetConfig.constructor.onLoadConfig(store);
  }, [widgetConfig]);

  return (
    <Form.Provider
      onFormFinish={(name, {values}) => onOk && onOk(values)}
    >
      <Modal
        title={t('widget.WidgetSettingsModal.title')}
        onOk={handleSubmit}
        visible
        width="90%"
        {...props}
      >
        <WidgetSettingsForm form={form} widgetConfig={widgetConfig}/>
      </Modal>
    </Form.Provider>
  );
};

export default WidgetSettingsModal;
